<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-toolbar text color="white">
          <v-toolbar-title>Commission Rules</v-toolbar-title>
          <v-divider class="mx-2" inset vertical></v-divider>

          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="80vw">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" @click="getRules"
                >Refresh</v-btn
              >
              <v-btn color="primary" dark class="mb-2" @click="newRule"
                >New Rule</v-btn
              >
              <v-btn color="primary" dark class="mb-2" @click="checkMissing"
                >Check Missing</v-btn
              >
            </template>
            <v-card>
              <v-card-title primary-title>
                <app-title>Edit Rule</app-title>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row v-if="editedItem">
                    <v-col
                      md="4"
                      v-for="(item, index) in getHeaders(editedItem).filter(
                        x => !x.text.includes('Raw')
                      )"
                      :key="index"
                    >
                      <v-text-field
                        v-model="editedItem[item.value]"
                        :label="item.text"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-btn color="primary" dark class="mb-2" @click="addDetail"
                      >Add New Detail</v-btn
                    >
                    <v-btn
                      color="primary"
                      dark
                      class="mb-2"
                      @click="saveDetails"
                      >Save Details</v-btn
                    >
                  </v-row>
                  <v-row>
                    <ag-grid-vue
                      style="width: 100%; height: 500px;"
                      class="ag-theme-balham"
                      :columnDefs="columnDefs"
                      :rowData="ratePlanDetails"
                      :gridOptions="gridOptions"
                      :defaultColDef="defaultColDef"
                      rowSelection="single"
                      enableCellTextSelection
                      @modelUpdated="onModelUpdated"
                    ></ag-grid-vue>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-btn color="blue darken-1" text @click="remove">Remove</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="save()">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
        <v-text-field
          name="search"
          label="Search"
          v-model="search"
          prepend-icon="search"
        ></v-text-field>
        <v-data-table
          v-if="items"
          :headers="headers"
          :items="items"
          class="elevation-1"
          :search.sync="search"
        >
          <!-- <template v-slot:item="{ item }">
            <td>
              {{ item }}
            </td>
          </template>
         -->
          <template v-slot:item.amount="{ item }">
            <td>
              {{ item.fixed ? "$" : "" }}{{ item.amount | formatMoney
              }}{{ item.fixed ? "" : "%" }}
            </td>
          </template>
          <template v-slot:item.action="{ item }">
            <td>
              <v-icon class="mr-2" @click="editItem(item)">edit</v-icon>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <check-missing
      :missingDialog="missingDialog"
      @closeDialog="missingDialog = false"
    ></check-missing>
  </v-container>
</template>

<script>
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import { mapActions, mapGetters } from "vuex";
import { AgGridVue } from "ag-grid-vue";

import CommissionRule from "@/models/CommissionRule";
import CheckMissing from "@/components/commissions/check-missing";
export default {
  name: "EditRules",
  components: {
    CheckMissing,
    AgGridVue
  },
  data() {
    return {
      gridOptions: {},
      defaultColDef: { resizeable: true, sortable: true },
      dialog: false,
      missingDialog: false,
      search: null,
      runType: 1,
      items: [new CommissionRule({})],
      editedItem: {},
      pagination: {
        descending: false,
        rowsPerPage: 20
      },
      ratePlanDetails: [],
      headers: [
        { text: "Rate Plan Id", value: "ratePlanId" },
        {
          text: "Plan Description",
          value: "planDescription"
        },
        { text: "Amount", value: "amount" },
        {
          text: "Dealer Level",
          value: "dealerLevelDescription"
        },
        {
          text: "Category",
          value: "categoryDescription"
        },
        {
          text: "Actions",
          value: "action"
        }
      ]
    };
  },
  methods: {
    ...mapActions("commissions", ["CommissionsRequest"]),

    checkMissing() {
      this.missingDialog = true;
    },

    newRule() {
      Object.assign(this.editItem, new CommissionRule());
      this.dialog = true;
    },
    addDetail() {
      this.ratePlanDetails.push({
        id: 0,
        ubRatePlanId: this.editedItem.ratePlanId,
        contractLength: 0,
        description: "",
        fixed: true,
        amount: 0.0,
        customerMustHavePaid: false,
        qbrBasePoints: 0,
        qbrBonusPoints: 0
      });
    },

    close() {
      this.dialog = false;
    },
    remove() {
      let query = {
        message: `Dealer Type added`,
        url: `Commissions/DeleteCommissionRule/`,
        method: "post",
        body: this.editedItem
      };
      this.CommissionsRequest(query)
        .then(data => {
          this.$emit("collected");
          this.items = data;
        })
        .catch(() => {});
    },
    save() {
      let vm = this;
      this.editedItem.amount = parseFloat(this.editedItem.amount);
      let query = {
        message: `Rule edited`,
        url: `Commissions/EditCommissionRule/`,
        method: "post",
        body: [this.editedItem]
      };
      this.CommissionsRequest(query)
        .then(data => {
          vm.$emit("collected");
          vm.editedItem = data;
          vm.dialog = false;
        })
        .catch(() => {});
    },
    saveDetails() {
      let vm = this;
      let query = {
        message: `Rule details updated`,
        url: `Commissions/UpdateRatePlanDetails/`,
        method: "post",
        body: this.ratePlanDetails
      };
      this.CommissionsRequest(query)
        .then(data => {
          vm.ratePlanDetails = data;
          vm.$emit("updated");
        })
        .catch(() => {});
    },
    getRules() {
      let query = {
        message: `Runs collected`,
        url: `Commissions/GetCommissionRules/0`,
        method: "get",
        body: {}
      };
      this.CommissionsRequest(query)
        .then(data => {
          this.$emit("collected");
          this.items = data.filter(x => x.dealerLevelID <= 2 && x.ratePlanId);
        })
        .catch(() => {});
    },
    editItem(val) {
      let vm = this;
      this.editedItem = val;
      let query = {
        message: ``,
        url: `Commissions/GetRatePlans/${val.ratePlanId}`,
        method: "get"
      };
      this.CommissionsRequest(query)
        .then(data => {
          vm.ratePlanDetails = data[0].ratePlanDetails;
        })
        .catch(() => {});
      this.dialog = true;
    },
    onModelUpdated() {
      this.gridOptions.api.sizeColumnsToFit();
    }
  },
  beforeMount() {
    this.gridOptions = {};
    this.columnDefs = [
      {
        headerName: "Description",
        field: "description"
      },
      {
        headerName: "Contract Length",
        field: "contractLength"
      },
      {
        headerName: "Amount",
        field: "amount"
      },
      {
        headerName: "Fixed",
        field: "fixed"
      },

      {
        headerName: "QBR Base",
        field: "qbrBasePoints"
      },
      {
        headerName: "QBR Bonus",
        field: "qbrBonusPOints"
      }
    ];
    this.defaultColDef = {
      sortable: true,
      filter: true,
      resizable: true,
      editable: true
    };
  }
};
</script>

<style scoped></style>
